import React from 'react'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {errorMessage} from 'lib/styleguide/base.scss'

export class DisableDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {pending: false, error: false}
  }

  onConfirm = () => {
    this.setState({pending: true})
    this.props.disable()
      .then(() => {
        this.setState({pending: false})
        this.props.closeDialog()
      }).catch(() => {
        this.setState({pending: false, error: true})
      })
  }

  render () {
    const {experience, closeDialog} = this.props
    const {pending, error} = this.state

    return (
      <ConfirmationDialog
        confirmText='Yes, Disable this Experience'
        onRequestClose={closeDialog}
        onCancel={closeDialog}
        onConfirm={this.onConfirm}
        confirmPending={pending}>
        <p>Disabling this Experience will prevent guests from accessing <strong>{experience.name}</strong>.</p>
        {error && <div className={errorMessage}>
          We encountered an error while disabling this Experience. Please try again.
        </div>}
      </ConfirmationDialog>
    )
  }
}
